export type TurnoverWindow = "1d" | "7d" | "30d";

const WINDOW_DAYS: Record<TurnoverWindow, number> = {
	"1d": 1,
	"7d": 7,
	"30d": 30,
};

const formattedTurnoverCache = new Map<number, string>();

const TURNOVER_RATIO_CAP = 999;

const turnoverRatioFormatter = new Intl.NumberFormat("en-US", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

/** Dailyized capital turnover: volume_window / days / tvl (ratio, not percent). */
export function computeTurnover(
	tvl: number,
	volume: number | undefined,
	window: TurnoverWindow,
): number | null {
	if (!Number.isFinite(tvl) || tvl <= 0) return null;
	if (volume === undefined || !Number.isFinite(volume) || volume < 0) return null;
	return volume / WINDOW_DAYS[window] / tvl;
}

/** Display dailyized volume / TVL as a ratio (0.42 → "0.42"). Caps extreme dust-TVL outliers. */
export function formatTurnover(value: number | null): string {
	if (value === null || !Number.isFinite(value)) return "—";

	const cached = formattedTurnoverCache.get(value);
	if (cached !== undefined) return cached;

	const formatted =
		value > TURNOVER_RATIO_CAP
			? `>${turnoverRatioFormatter.format(TURNOVER_RATIO_CAP)}`
			: turnoverRatioFormatter.format(value);

	formattedTurnoverCache.set(value, formatted);
	return formatted;
}

export function passesVolTvlFilter(turnover1d: number | null, filterId: string): boolean {
	if (filterId === "all") return true;
	const min = Number(filterId);
	if (!Number.isFinite(min)) return true;
	return turnover1d !== null && turnover1d >= min;
}
